/* eslint-disable @typescript-eslint/no-unused-vars */
import { IEngineHistory, IEngineHistoryParams } from "@/@types/engine-history";
import { Paginated } from "@/@types/paginated";
import { Tags } from "@/enum/tags";
import { apiSlice } from "./http";

export const EngineHistoryApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEngineHistory: builder.query<
      Paginated<IEngineHistory>,
      IEngineHistoryParams
    >({
      query: ({
        meta,
        search,
        type_request,
        type_solicitation,
        created_at,
      }) => {
        const paramsObj: Record<string, string | undefined> = {
          search: search,
          type_request: type_request?.toString(),
          type_solicitation: type_solicitation?.toString(),
          created_at,
          page: meta.page?.toString(),
          perPage: meta.perPage?.toString(),
        };

        const params = new URLSearchParams(
          Object.entries(paramsObj)
            .filter(([_, value]) => value !== undefined && value !== '')
            .reduce(
              (acc, [key, value]) => ({ ...acc, [key]: value as string }),
              {}
            )
        );

        return {
          url: `/engine-fiscal/history?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.ENGINE_HISTORY],
    }),
  }),

  overrideExisting: true,
});

export const { useGetEngineHistoryQuery } = EngineHistoryApi;

export const {
  endpoints: {
    getEngineHistory: { select: selectEngineHistory },
  },
} = EngineHistoryApi;
